import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tabs } from "antd";
import SearchView from "@/components/search-view/SearchView";
import { getGreeting } from "@/utils/searchBang.util";
const DATA = [
    {
        "tab": "Quick Links",
        "urls": [
            { "name": "Reddit", "domain": "reddit.com", "url": "https://www.reddit.com/" },
            { "name": "Notion", "domain": "notion.so", "url": "https://www.notion.so/" },
            { "name": "Pocket Saves", "domain": "getpocket.com", "url": "https://getpocket.com/saves" },
            { "name": "GitHub", "domain": "github.com", "url": "https://github.com/" },
            { "name": "TickTick", "domain": "https://ticktick.com", "url": "https://ticktick.com/webapp/#q/all/tasks" },
            { "name": "Youtube", "domain": "youtube.com", "url": "https://youtube.com/" },
            { "name": "Medium", "domain": "medium.com", "url": "https://medium.com/" }
        ]
    },
    {
        "tab": "Finance",
        "urls": [
            { "name": "ICICI", "domain": "icicibank.com", "url": "https://www.icicibank.com/" },
            { "name": "TMB", "domain": "tmb.in", "url": "https://www.tmbnet.in/" },
            { "name": "HDFC", "domain": "hdfcbank.com", "url": "https://netbanking.hdfcbank.com/netbanking/" },
            { "name": "Axis Bank", "domain": "axisbank.com", "url": "https://omni.axisbank.co.in/axisretailbanking/" },
            { "name": "UAN Portal", "domain": "epfindia.gov.in", "url": "https://unifiedportal-mem.epfindia.gov.in/memberinterface/" },
            { "name": "PF Passbook", "domain": "epfindia.gov.in", "url": "https://passbook.epfindia.gov.in/" },
            { "name": "LIC Customer Portal", "domain": "licindia.in", "url": "https://www.licindia.in/Customer-Portal" },
            { "name": "IT Filing", "domain": "incometax.gov.in", "url": "https://www.incometax.gov.in/iec/foportal/" },
            { "name": "Clear Tax", "domain": "cleartax.in", "url": "https://cleartax.in/" },
            { "name": "SBI Netbanking", "domain": "sbi.co.in", "url": "https://retail.onlinesbi.com/retail/login.htm" }
        ]
    },
    {
        "tab": "Connection",
        "urls": [
            { "name": "ProtonMail", "domain": "proton.me", "url": "https://mail.proton.me/u/0/inbox" },
            { "name": "GMail", "domain": "workspace.google.com", "url": "https://mail.google.com/mail/u/0/#inbox" },
            { "name": "Google Calendar", "domain": "google.com", "url": "https://calendar.google.com/calendar/u/0/r" },
            { "name": "LinkedIn", "domain": "linkedin.com", "url": "https://www.linkedin.com/feed/" },
            { "name": "Twitter", "domain": "x.com", "url": "https://x.com/" },
            { "name": "FB", "domain": "fb.com", "url": "https://fb.com/" },
            { "name": "Discord", "domain": "discord.com", "url": "https://discord.com/app" },
            { "name": "Instagram", "domain": "instagram.com", "url": "https://www.instagram.com/" },
            { "name": "WhatsApp Web", "domain": "web.whatsapp.com", "url": "https://web.whatsapp.com/" }
        ]
    },
    {
        "tab": "OTT",
        "urls": [
            { "name": "Amazon Prime", "domain": "primevideo.com", "url": "https://www.primevideo.com/" },
            { "name": "Hotstar", "domain": "hotstar.com", "url": "https://www.hotstar.com/" },
            { "name": "Sunnxt", "domain": "sunnxt.com", "url": "https://www.sunnxt.com/" },
            { "name": "Sonyliv", "domain": "sonyliv.com", "url": "https://www.sonyliv.com/" },
            { "name": "Zee5", "domain": "zee5.com", "url": "https://www.zee5.com/" },
            { "name": "Netflix", "domain": "netflix.com", "url": "https://www.netflix.com/" }
        ]
    },
    {
        "tab": "Productivity",
        "urls": [
            { "name": "Trello", "domain": "trello.com", "url": "https://trello.com/" },
            { "name": "Canva", "domain": "canva.com", "url": "https://www.canva.com/" },
            { "name": "Udemy", "domain": "udemy.com", "url": "https://www.udemy.com/" }
        ]
    },
    {
        "tab": "Shopping",
        "urls": [
            { "name": "Amazon", "domain": "amazon.in", "url": "https://www.amazon.in/" },
            { "name": "Flipkart", "domain": "flipkart.com", "url": "https://www.flipkart.com/" },
            { "name": "Myntra", "domain": "myntra.com", "url": "https://www.myntra.com/" }
        ]
    },
];
const HeroWidget = () => {
    return (_jsx("div", { className: "rounded-3xl h-full shadow-lg bg-white overflow-auto hide-scrollbar w-full", children: _jsxs("div", { className: "home-hero-container pt-36", children: [_jsxs("div", { className: "mx-auto w-full min-w-[300px] max-w-[800px] px-8 mb-8", children: [_jsx("h2", { className: "mb-12 text-center font-semibold text-primary text-5xl", children: getGreeting() }), _jsx(SearchView, {})] }), _jsx("div", { className: "min-w-[800px] max-w-[800px] mx-auto mb-6", children: _jsx(Tabs, { centered: true, defaultActiveKey: DATA[0].tab, animated: { inkBar: true, tabPane: true }, size: "middle", items: DATA.map((data) => ({
                            key: data.tab,
                            label: data.tab,
                            children: (_jsx("div", { className: "flex flex-wrap gap-8 justify-center items-start", children: data.urls.map((bookmark) => (_jsxs("a", { href: bookmark.url, rel: "noopener noreferrer", className: "w-24 h-24 card rounded-xl flex flex-col items-center justify-center", title: bookmark.name, children: [_jsx("img", { className: "w-8 h-8", src: `https://www.google.com/s2/favicons?sz=64&domain=${bookmark?.domain}`, alt: bookmark.name }), _jsx("div", { className: "text-white text-center mt-3 text-xs font-medium truncate whitespace-nowrap overflow-hidden w-4/5", children: bookmark.name })] }, bookmark.url))) })),
                        })) }) })] }) }));
};
export default HeroWidget;
